/**
 * Parcels Details
 */

// React
import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../..//theme';
import {
  Typography,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Box,
  ClickAwayListener,
  IconButton,
  Collapse,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiStateMachine,
  mdiKeyOutline,
  mdiWarehouse,
  mdiArrowRight,
  mdiPackage,
  mdiCalendar,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiPrinter,
  mdiArchiveOutline,
  mdiCityVariant,
  mdiCounter,
  mdiChevronUp,
  mdiChevronDown,
} from '@mdi/js';

// Components
import ListParcelItems from './list';
import Can from '../..//components/Can';
import CSV from './csv';
import LabelList from '../..//pages/parcelInventoryItems/components/labelsList';
import Modal from '../..//components/Modal';

// Helper
import {
  translate,
  removeEmptyValueObject,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { SelectorProps, Props } from './interfaces';
import Pagination from '@material-ui/lab/Pagination';
import RenderFilter, { Filter } from '../..//utils/listDaynamicFilter';
import clsx from 'clsx';
import parcelsRepository from 'client-sdk/src/Repository/parcels-repository';
import handleError from '../../utils/handleError';
import inventoryItemsRepository from 'client-sdk/src/Repository/inventory-items-repository';
import handleNotfication from '../../utils/handleNotification';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
      '& .MuiCollapse-container, & .MuiCollapse-entered': {
        width: '100%'
      }
    },
    paper: {
      marginTop: '16px',
      marginBottom: '16px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    title: {
      fontWeight: 500,
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '70%',
      marginTop: '30px',
      top: '180px',
      right: '33px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    collapseIcon: {
      marginTop: '-36px',
      textAlign: 'center',
      position: 'relative',
      width: '100%',
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '40px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: theme.palette.secondary.main,
        border: '5px solid white',
      },
    },
  })
);

export function Details(props: Props) {
  const authContext = useContext(AuthContext);
  const [filters, setFilters] = useState([] as Filter[]);
  const [filtersValues, setFiltersValues] = useState({
    outgoingParcelId: { equals: props.match.params.id },
    page: 0,
    size: 10000,
  } as any);
  const [open, setOpen] = React.useState(false);
  const [error, setError] = useState('');
  const [inventoryItemsError, setInventoryItemsError] = useState("");
  const [inventoryItemsWithSerialError, setInventoryItemsWithSerialError] = useState("");
  const [loading, setLoading] = useState(false);
  const [inventoryItemsLoading, setInventoryItemsLoading] = useState(false);
  const [inventoryItemsWithSerialLoading, setInventoryItemsWithSerialLoading] = useState(false);
  const [parcel, setParcel] = useState({});
  const [inventoryItems, setInventoryItems] = useState([]);
  const [inventoryItemsWithSerial, setInventoryItemsWithSerial] = useState([]);
  const [inventoryItemsCount, setInventoryItemsCount] = useState(0);
  const [printModal, setPrintModal] = useState(false as boolean);
  const [openFilterBox, setOpenFilterBox] = React.useState(false);
  const [selected, setSelected] = React.useState<string[]>([]);
  const classes = useStyles();

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'productName.contains',
        label: 'نام کالا',
        icon: mdiArchiveOutline,
      },
      {
        type: 'input',
        id: 'productCode.contains',
        label: 'کد کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'number',
        id: 'productId.equals',
        label: 'شناسه کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'number',
        id: 'skuId.equals',
        label: 'شناسه تنوع کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'input',
        id: 'skuCode.contains',
        label: 'کد تنوع کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'input',
        id: 'serialNumber.equals',
        label: 'سریال کالا',
        icon: mdiKeyOutline,
      },
    ]);
  };

  const getParcelWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await parcelsRepository.getParcelsWithId({ payload });
      setParcel(response.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  }
  const clearnParcelInventoryItems = () => {
    setInventoryItemsError('');
    setInventoryItemsCount(0);
    setInventoryItems([]);
  }
  const getInventoryItemsWithSerial = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsWithSerialLoading(true);
      const {
        response,
        callback
      } = await inventoryItemsRepository.getInventoryItemsWithSerial(
        { payload },
        payload.callback
      );
      if (callback) {
        callback();
      }
      setInventoryItemsWithSerial(response.data.content);
      if (response.data.content.length === 0)
        handleNotfication('هیچ آیتمی پیدا نشد.', 'warn');
    } catch (error) {
      setInventoryItemsWithSerialError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsWithSerialLoading(false);
    }
  }
  useEffect(() => {
    const { id } = props.match.params;
    getParcelWithId(id);
    getInventoryItemsWithSerial({
      ...filtersValues,
    });
    return () => {
      clearnParcelInventoryItems();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  // useEffect(() => {
  //   const {id} = props.match.params;
  //   props.getParcelWithIdActionDispatch(id);
  //   props.getInventoryItemsWithSerialActionDispatch({
  //     ...filtersValues,
  //   });
  //   return () => {
  //     props.clearnParcelInventoryItemsDispatch();
  //   };
  // }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const getParcelInventoryItem = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsLoading(true);
      const {
        response,
        callback
      } = await inventoryItemsRepository.getParcelInventoryItems({ payload });
      if (callback) {
        callback();
      }
      setInventoryItems(response.data.content);
      setInventoryItemsCount(response.data.totalElements);
    } catch (error) {
      setInventoryItemsError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsLoading(false);
    }

  }
  useEffect(() => {
    getParcelInventoryItem({
      ...filtersValues,
    });
    setupFilters();
  }, [filtersValues]);

  const handleCollapse = () => {
    setOpen(!open);
  };

  const handleClickFilter = () => {
    setOpenFilterBox(prev => !prev);
  };

  useEffect(() => {
    setFiltersValues({
      outgoingParcelId: { equals: props.match.params.id },
      page: 0,
      size: 10000,
    });
  }, [printModal]);

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
      'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  const handleOpenPrintModal = () => {
    setPrintModal(true);
  };

  const handleClosePrintModal = () => {
    setPrintModal(false);
  };

  const handleClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.inventoryItems.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClickPrint = () => {
    props.history.push(
      `/print-labels/${props.match.params.id}?items=${selected.join(',')}`
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات قبض خروج 
        ${parcel.receiptTitle}

     
        `}
        </Typography>
        <span className={classes.contentlabelTitle}>{parcel.id}</span>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {`بازگشت`}
        </Button>

        <Can
          role={authContext.user.role}
          perform="/parcels/receipts/:id"
          yes={() => (
            <Link
              to={`/parcels/outgoing-receipts/${parcel.id}`}
              target="_blank"
              style={{ textDecoration: 'none' }}
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiPrinter} size={1} />}
              >
                {authContext.user.role === 'WAREHOUSE_OPERATOR' ||
                  authContext.user.role === 'WAREHOUSE_ADMIN'
                  ? 'چاپ رسید'
                  : 'چاپ حواله'}
              </Button>
            </Link>
          )}
        />
      </Grid>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiWarehouse}
                  size={1}
                  className={classes.icon}
                />
                {'شناسه قبض:  '}
              </span>

              <span>{parcel.id}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiPackage} size={1} className={classes.icon} />
                {'عنوان قبض:  '}
              </span>

              <span>{parcel?.receiptTitle}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCounter} size={1} className={classes.icon} />
                {'تعداد آیتم های محموله:  '}
              </span>

              <span>{inventoryItemsCount}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {'تاریخ خروج:  '}
              </span>
              <span>
                <span>
                  {parcel.shippingDate &&
                    `${jMoment(parcel.deliveryDate, 'YYYY/MM/DD')
                      .locale('fa')
                      .format('jYYYY/jMM/jDD')}`}
                </span>
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <div className={classes.collapseIcon}>
            <IconButton onClick={handleCollapse}>
              <Icon
                path={open ? mdiChevronUp : mdiChevronDown}
                color="white"
                size={1}
              />
            </IconButton>
          </div>

          <Collapse in={open} timeout="auto" unmountOnExit>
            <Grid style={{ margin: 0, width: '100%' }} xs={12} container spacing={3}>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiCityVariant} size={1} className={classes.icon} />
                    {'ارسال کننده:  '}
                  </span>
                  <span>{parcel.partnerName ?? parcel.sellerName}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiCalendar} size={1} className={classes.icon} />
                    {'تاریخ ایجاد قبض:  '}
                  </span>
                  <span>
                    <span>
                      {parcel.shippingDate &&
                        `${jMoment(parcel.shippingDate, 'YYYY/MM/DD')
                          .locale('fa')
                          .format('jYYYY/jMM/jDD')}`}
                    </span>
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendarClock}
                      size={1}
                      className={classes.icon}
                    />
                    {'بازه خروج:  '}
                  </span>
                  <span>
                    <span>
                      {parcel.deliveryStartTime &&
                        jMoment(parcel.deliveryStartTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                      {' - '}
                      {parcel.deliveryEndTime &&
                        jMoment(parcel.deliveryEndTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                    </span>
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiStateMachine}
                      size={1}
                      className={classes.icon}
                    />
                    {'وضعیت تحویل :  '}
                  </span>
                  <span>{translate(parcel.status, 'parcel')}</span>
                </div>
              </Grid>
            </Grid>
          </Collapse>
        </Grid>
      </Paper>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {props.loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            inventoryItemsWithSerial && (
              <>
                <Grid item xs={12}>
                  <div style={{ textAlign: 'left' }}>
                    <Can
                      role={authContext.user.role}
                      perform="parcels-detail:downloadCSV"
                      yes={() => (
                        <>
                          {parcel?.items?.length && (
                            <CSV
                              ordersDispatch={
                                props.getParcelInventoryItemDispatch
                              }
                              data={inventoryItemsWithSerial}
                              filtersValues={filtersValues}
                              loading={inventoryItemsLoading}
                            />
                          )}
                        </>
                      )}
                    />
                  </div>
                  <Box mb={3} />
                </Grid>
                <ListParcelItems data={inventoryItemsWithSerial} />
              </>
            )
          )}
        </Grid>
      </Grid>

      <Modal
        maxWidth="xl"
        onClose={handleClosePrintModal}
        open={printModal}
        title={
          <div style={{ textAlign: 'center' }}>
            <Icon path={mdiPrinter} size={4} color={theme.palette.green.main} />
          </div>
        }
        content={
          <Grid container>
            <Grid
              container
              justify="flex-end"
              item
              xs={12}
              style={{ marginBottom: '5px' }}
            >
              <ClickAwayListener onClickAway={handleClickAway}>
                <div>
                  <Button
                    type="button"
                    onClick={handleClickFilter}
                    className={classes.iconButton}
                    aria-label="search"
                  >
                    {openFilterBox ? 'بستن' : 'جستجوی پیشرفته'}
                  </Button>
                  {openFilterBox ? (
                    <div
                      className={clsx(classes.filterBox, {
                        [classes.filterOpen]: openFilterBox,
                      })}
                    >
                      <RenderFilter
                        filters={filters}
                        onFilter={(filtervalues: any) => {
                          setFiltersValues({
                            ...removeEmptyValueObject(filtervalues),
                            outgoingParcelId: { equals: props.match.params.id },
                            page: 0,
                            size: 100,
                          });
                          setOpenFilterBox(false);
                        }}
                        setOpenFilterBox={setOpenFilterBox}
                      />
                    </div>
                  ) : null}
                </div>
              </ClickAwayListener>
            </Grid>
            <Grid xs={12} style={{ marginBottom: '20px', marginTop: '20px' }}>
              <LabelList
                selected={selected}
                handleSelectAllClick={handleSelectAllClick}
                handleClick={handleClick}
                data={props.inventoryItems}
              />
            </Grid>
            <Box mb={4} />
            <Grid xs={12} container justify="space-between" alignItems="center">
              <Pagination
                count={Math.ceil(
                  props.inventoryItemsCount / filtersValues.size
                )}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
              <Button
                disabled={selected.length < 1}
                variant="contained"
                color="secondary"
                size="large"
                onClick={handleClickPrint}
                startIcon={<Icon path={mdiPrinter} size={1} />}
              >
                {'پرینت سریال‌ها'}
              </Button>
            </Grid>
          </Grid>
        }
      />
    </div>
  );
}

export default Details;
